import { DataTable } from "@/components/tool-kit/primitives";
import { WIDGET_H3 } from "@/components/tool-kit/styles";
import type { PlanSection } from "@/lib/tool-kit/games-organizers/unit-plan";

/** The plan as a document: headings, bullet lists and one table per week. */
export default function UnitPlanDocument({
  sections,
  placeholder,
}: {
  sections: readonly PlanSection[];
  /** Text that marks a part still to be written; it is shown muted. */
  placeholder: string;
}) {
  return (
    <div className="space-y-4 rounded-lg border border-border bg-card p-4 sm:p-6">
      {sections.map((section, index) => {
        const Heading = section.level === 2 ? "h3" : "h4";
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: headings repeat; sections are positional
          <section className="space-y-2" key={index}>
            <Heading
              className={
                section.level === 2
                  ? WIDGET_H3
                  : "font-semibold text-base text-foreground"
              }
            >
              {section.heading}
            </Heading>
            {section.paragraphs.map((paragraph) => (
              <p
                className={
                  paragraph === placeholder
                    ? "text-muted-foreground text-sm italic"
                    : "text-foreground text-sm"
                }
                key={paragraph}
              >
                {paragraph}
              </p>
            ))}
            {section.items.length > 0 ? (
              <ul className="m-0 list-disc space-y-1 pl-5 text-foreground text-sm">
                {section.items.map((item) => (
                  <li
                    className={
                      item === placeholder
                        ? "text-muted-foreground italic"
                        : undefined
                    }
                    key={item}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            ) : null}
            {section.table ? (
              <DataTable head={section.table.head} rows={section.table.rows} />
            ) : null}
          </section>
        );
      })}
    </div>
  );
}
